export default "__VITE_ASSET__Bi3yTz1$__"